import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VEHICLE_OCCUPANT_INJURY_VALUES = {
  YES: 'yes',
  NO: 'no',
  IDK: 'does_not_know',
} as const;

export const VEHICLE_OCCUPANT_INJURY_NAME = 'vehicle_occupant_injury';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupVehicleOccupantInjury: FC<Props> = ({
  name = VEHICLE_OCCUPANT_INJURY_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy ktoś w Twoim pojeździe doznał obrażeń?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field}>
              <RadioItem
                value={VEHICLE_OCCUPANT_INJURY_VALUES.YES}
                label={i18n.t('Tak')}
                data-testid="radio-group-vehicle-occupant-injury-yes"
              />
              <RadioItem
                value={VEHICLE_OCCUPANT_INJURY_VALUES.NO}
                label={i18n.t('Nie')}
                data-testid="radio-group-vehicle-occupant-injury-no"
              />
              <RadioItem
                value={VEHICLE_OCCUPANT_INJURY_VALUES.IDK}
                label={i18n.t('Nie wiem')}
                data-testid="radio-group-vehicle-occupant-injury-dont-know"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
